import "./BarWithImageChartComponent.scss";

import { Box, Typography } from "@mui/material";

import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import React from "react";
import ReactApexChart from "react-apexcharts";

const barHeight = 60;
const barGap = 2;




interface BarWithImageChartComponentProps  {
  data: { name: string; logo: string; value: number; color: string; diff: number; trend: string }[];
  series: any[];
    maxValue: number;  
}

const BarWithImageChartComponent = ({data = [], series = [], maxValue = 100}: BarWithImageChartComponentProps) => { 
  const options = {
    chart: {
      type: "bar" as const,
      height: 350,
      toolbar: { show: false },
      sparkline: { enabled: true },
      animations: { enabled: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "40px",
        borderRadius: 0,
        distributed: true,
        dataLabels: {
          position: "right",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      show: true,
      labels: { show: false },
      axisBorder: { show: true },
      axisTicks: { show: false },
      max: 100,
    },
    yaxis: { show: true },
    grid: { show: true },
    legend: { show: false },
    colors: data.map((d: { color: string }) => d.color),
    tooltip: { enabled: false },
  };

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          height: (barHeight + barGap) * data.length - barGap,
        }}
      >
        {/* Chart */}
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={barHeight * data.length + barGap * (data.length - 1)}
        />

        {/* Overlay images and custom labels */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
          }}
        >
          {data.map((d, i) => {
            const percent = (d.value / 100) * 100;
            const trendIcon =
              d.trend === "up" ? (
                <CallMadeIcon style={{ fontSize: 14 }} />
              ) : (
                <CallReceivedIcon style={{ fontSize: 14 }} />
              );
            const color = d.trend === "up" ? "#38A169" : "#E53E3E";
            const isFull = percent >= 90;
            return (
              <Box
                key={i}
                sx={{
                  position: "absolute",
                  top: `${i * (barHeight + barGap)}px`,
                  left: 0,
                  width: "100%",
                  height: `${barHeight}px`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* Custom Gemini gradient overlay */}
                {d.name === "Gemini" && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      width: `${percent}%`,
                      height: "40px",
                      // borderRadius: 1,
                      background: "linear-gradient(90deg, #3B6EF6 0%, #E85B6B 100%)",
                      zIndex: 0,
                      transform: "translateY(-50%)",
                    }}
                  />
                )}
                {/* Image inside bar */}
                <Box
                  component="img"
                  src={d.logo}
                  alt={d.name}
                  sx={{
                    width: 50,
                    // borderRadius: 1,
                    ml: 1,
                    objectFit: "contain",
                    zIndex: 1,
                    left: 10,
                    transform: "translateX(-125%)",
                  }}
                />
                {/* Custom label */}
                <Box
                  sx={{
                    position: "absolute",
                    left: isFull
                      ? `calc(${percent}% - 80px)`
                      : `calc(${percent}% + 10px)`,
                    color,
                    borderRadius: 2,
                    fontSize: 12,
                    height: "40px",
                    whiteSpace: "nowrap",
                    zIndex: 2,
                    top: "50%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: d.trend === "up" ? "#2E7D3214" : "#D32F2F14",
                      borderRadius: "4px",
                      px: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {trendIcon}
                    </Box>
                    <Typography
                      sx={{ fontSize: 12, color: color, fontWeight: "medium" }}
                    >{`${d.diff}%`}</Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default BarWithImageChartComponent;